module.exports = __webpack_public_path__ + "img/tears.40679645.png";